import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  getListingFullAddressString,
} from 'common/listingHelpers';

import {
  createFormValidationFn,
  hideFieldIf,
} from 'client/helpers/formikHelpers';

import {
  cleanMarketingPartnerListingFormValues,
} from 'common/marketingPartnerListingHelpers';

import {
  SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING,
} from 'api/actionTypes';

import {
  MARKETING_PARTNER_LISTING_STATUS_TEMPORARILY_OFF_MARKET,
  MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OPTION_ITEMS,
  MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OTHER,
} from 'common/marketingPartnerListingConstants';

import log from 'client/lib/log';

import postWithState from 'client/actions/postWithState';

import SrFooterButton from 'client/components/SrFooterButton/SrFooterButton';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrPartnerPageV2, { SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL } from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

class SrPartnerTemporarilyOffMarketForm extends Component {
  static propTypes = {
    partner: PropTypes.object.isRequired,
    marketingPartnerListing: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      shouldShowSuccessModal: false,
      shouldShowLoadingScreen: false,
    };
  }

  _onSubmit = (formValues) => {
    const { partner, marketingPartnerListing, dispatch, onSubmit } = this.props;
    const updates = cleanMarketingPartnerListingFormValues({
      ...marketingPartnerListing,
      ...formValues,
      status: MARKETING_PARTNER_LISTING_STATUS_TEMPORARILY_OFF_MARKET,
      partnerId: partner.id,
    });

    dispatch(postWithState, {
      action: SR_API_ACTION_PARTNER_UPDATE_MARKETING_LISTING,
      payload: {
        updates,
        marketingPartnerListingId: marketingPartnerListing.id,
      },
      onSuccess: () => {
        this.setState({
          shouldShowSuccessModal: true,
        });
        setTimeout(() => {
          onSubmit();
        }, 1000);
      },
      onError: (error) => {
        log.error(error);
      },
    });
  }

  _getFormFields = ({ values = {} } = {}) => {
    return [
      {
        id: 'temporarilyOffMarketReason',
        title: 'Reason for the change?',
        type: 'select',
        properties: {
          choices: MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OPTION_ITEMS,
          enableResetOption: true,
        },
        validations: ['required'],
      },
      hideFieldIf(!(
        values.temporarilyOffMarketReason === MARKETING_PARTNER_LISTING_TEMPORARILY_OFF_MARKET_REASON_OTHER
      ), {
        id: 'temporarilyOffMarketReasonProvided',
        title: 'Other reason for taking it temporarily off-market?',
        type: 'long_text',
        properties: {
          placeholder: 'Write here...',
        },
        validations: ['required'],
      }),
      {
        id: 'bringBackToMarketDate',
        title: 'Date to bring the listing back on market?',
        titleSecondary: '(optional)',
        type: 'date_picker',
        properties: {
          placeholder: 'MM/DD/YYYY',
          dateFormat: 'MM/DD/YYYY',
        },
      },
    ];
  };

  render() {
    const {
      marketingPartnerListing,
      onBack,
    } = this.props;

    const {
      shouldShowSuccessModal,
      shouldShowLoadingScreen,
    } = this.state;

    if (shouldShowLoadingScreen) {
      return <div className='loading-gif' />;
    }

    return (
      <Formik
        ref={(formik) => {
          this.formik = formik;
        }}
        validate={(values) => {
          const formFields = this._getFormFields({ values });
          return createFormValidationFn(formFields)(values);
        }}
        onSubmit={(formValues) => {
          this._onSubmit(formValues);
        }}
      >
        {(formikBag) => {

          return (
            <>
              <Form className='form'>
                <SrPartnerPageV2
                  onBack={onBack}
                  navbarTitle={getListingFullAddressString(marketingPartnerListing.listing)}
                  pageHeader='Temporarily take my listing off-market'
                  headerSize={SR_PARTNER_PAGE_V2_FONT_SIZE_SMALL}
                >
                  <SrBox
                    backgroundColor='#ffffff'
                    borderRadius='14px'
                    padding='23px 20px 30px 20px'
                  >
                    {this._getFormFields({
                      values: formikBag.values,
                    }).map((formField, index) => (
                      <SrFormikField
                        formField={formField}
                        formikBag={formikBag}
                        theme={SR_FIELD_THEME_ADOBE}
                        margin={index === 0 ? '0' : null}
                        key={formField.id}
                      />
                    ))}
                  </SrBox>
                </SrPartnerPageV2>
                <SrStaticFooter>
                  <SrText
                    display='block'
                    lineHeight='25px'
                    font='greycliff'
                    color='grey600'
                    fontSize='13px'
                    weight='500'
                  >
                    Updates can take 24 hours to syndicate
                  </SrText>
                  <SrFooterButton
                    disabled={!formikBag.isValid}
                    hasBoxShadow={formikBag.isValid}
                  >
                    Take Off-Market
                  </SrFooterButton>
                </SrStaticFooter>
              </Form>
              {shouldShowSuccessModal && (
                <SrSimpleMessageModal
                  iconUrl='/images/checkmark-circle-large-green.svg'
                  headline='Saved!'
                  maxWidth='375'
                  minWidth='320'
                  theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
                />
              )}
            </>
          );
        }}
      </Formik>
    );
  }
}

SrPartnerTemporarilyOffMarketForm.displayName = 'SrPartnerTemporarilyOffMarketForm';

export default SrPartnerTemporarilyOffMarketForm;
